import { ThresholdData } from '@cmps/ng-kit';

import { bgGradient } from '../../common/pipe/bg-gradient';
import { StagingKpiThreshold } from '../models/staging-kpi-threshold.model';
import { WpCoachingCard } from '../models/wp-coaching-card.model';

export function getProgressDataWinningPct(
    wpCoachingCard: WpCoachingCard,
    coachingCardThreshold: StagingKpiThreshold[],
): ThresholdData[] {
    const baseTarget = wpCoachingCard.winningTarget * 100;
    const thresholdOne =
        coachingCardThreshold[0] != null
            ? baseTarget * coachingCardThreshold[0].rangeEnd
            : 0;
    const thresholdTwo =
        coachingCardThreshold[1] != null
            ? baseTarget * coachingCardThreshold[1].rangeEnd
            : 0;
    const thresholdThree = 100;
    const score = wpCoachingCard.winning * 100;

    const thresholds: ThresholdData[] = [
        {
            color: coachingCardThreshold[0]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[0]?.rangeColour ?? '#000000',
            }),
            startValue: 0,
            endValue: thresholdOne,
            enabled: score >= 0 && score < thresholdOne,
        },
        {
            color: coachingCardThreshold[1]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[1]?.rangeColour ?? '#000000',
            }),
            startValue: thresholdOne,
            endValue: thresholdTwo,
            enabled: score >= thresholdOne && score < thresholdTwo,
        },
        {
            color: coachingCardThreshold[2]?.rangeColour ?? '#000000',
            colorGradient: bgGradient({
                color: coachingCardThreshold[2]?.rangeColour ?? '#000000',
            }),
            startValue: thresholdTwo,
            endValue: thresholdThree,
            enabled: score >= thresholdTwo,
        },
    ];

    return thresholds;
}
